/**
 * 应用市场
 * zxw
 * 创建时间 2026-01-29
 */

import CNF from "../../incs/Config";
import {
    winHeight,
    AddRequestHeaders,
    UjoinParams,
} from "../../incs/FunHelper";
import { TextIcon } from "../../incs/Icons";
import { useState, useEffect } from "react";
import $ from 'jquery';
import {
    message,
    Row,
    Col,
    Segmented,
    Input,
    Flex,
    theme,
    Button,
    Space,
    Avatar,
    Card,
    Typography,
    Tooltip,
    Tag,
} from 'antd';
import {
    SearchOutlined,
    NodeIndexOutlined,
    PlayCircleOutlined,
} from '@ant-design/icons';

const { Text, Paragraph } = Typography;

const AppMarket = (props) => {
    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            colorPrimaryBorder,
            colorPrimaryText,
            colorBgSolid,
            colorBgActive,
            colorTextBase,
            colorTextMenu,
            colorBgContent,
            colorBasePlaceholder,
            fontSizeLG,
            fontSizeSM,
        },
    } = theme.useToken();

    const [messageApi, contextHolder] = message.useMessage();

    // 应用列表
    const [appList, setAppList] = useState([]);

    const [isSuggest, setIsSuggest] = useState(1);
    const [appName, setAppName] = useState('');
    const [appType, setAppType] = useState([]);     // 应用类型
    const [appModal, setAppModal] = useState([]);   // 应用模态
    const [appFiled, setAppFiled] = useState([]);   // 应用领域

    const marginBottom = 8;

    const [hoverIndex, setHoverIndex] = useState(-1);


    /**
     * 应用类型
     * @param {*} value 
     */
    const changeAppType = (value) => {
        if (appType.indexOf(value) > -1) {
            setAppType(appType.filter(item => item !== value));
        } else {
            setAppType([...appType, value]);
        }
    }

    /**
     * 应用模态
     * @param {*} value 
     */
    const changeAppModal = (value) => {
        if (appModal.indexOf(value) > -1) {
            setAppModal(appModal.filter(item => item !== value));
        } else {
            setAppModal([...appModal, value]);
        }
    }

    /**
     * 应用领域
     * @param {*} value 
     */
    const changeAppFiled = (value) => {
        if (appFiled.indexOf(value) > -1) {
            setAppFiled(appFiled.filter(item => item !== value));
        } else {
            setAppFiled([...appFiled, value]);
        }
    }

    // 初始化应用信息
    useEffect(() => {
        const getAppList = () => {
            const params = {
                is_suggest: isSuggest ? isSuggest : '',
                is_publish: CNF.BOOLEAN_TRUE,
                app_name: appName,
                app_type: appType,
                app_filed: appFiled,
            };
            $.ajax({
                url: `${CNF.api}app/infos${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
            })
                .done(function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setAppList(data.dat);
                        } else {
                            setAppList([]);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                })
                .fail(function (data) {
                    messageApi.error(data.responseJSON.detail, CNF.messageDuration);
                })
        }
        getAppList();
    }, [isSuggest, appName, appType, appModal, appFiled]);

    return <>
        {/* 搜索栏 */}
        <div style={{
            height: CNF.contentHeaderHeight,
            borderBottom: 'solid 1px',
            borderBottomColor: colorBgSolid,
            padding: `0 ${CNF.basePadding}px`,
        }}>
            {contextHolder}
            <Row style={{
                height: CNF.contentHeaderHeight,
                display: 'flex',
                alignItems: 'center',
            }}>
                <Col span={8}>
                    <Text strong style={{ color: colorTextBase, fontSize: fontSizeLG }}>{props.menuName}</Text>
                </Col>
                <Col span={8} style={{ textAlign: 'center' }}>
                    <Segmented
                        options={['精选应用', '全部应用']}
                        style={{
                            color: colorTextBase,
                        }}
                        onChange={value => setIsSuggest(value === '精选应用' ? 1 : 0)}
                    />
                </Col>
                <Col span={4} offset={4}>
                    <Input
                        placeholder='搜索应用'
                        style={{
                            backgroundColor: colorBgContent,
                        }}
                        prefix={<SearchOutlined style={{ color: colorBasePlaceholder }} />}
                        value={appName}
                        onChange={(e) => setAppName(e.target.value)}
                    />
                </Col>
            </Row>
        </div>
        {/* 搜索栏 */}

        <Flex>
            {/* 标签栏 */}
            <div style={{
                height: winHeight - CNF.menuHeight - CNF.contentHeaderHeight - 9,
                width: '14%',
                borderRight: `1px solid ${colorBgSolid}`,
                padding: CNF.basePadding,
            }}>
                <div style={{ color: colorTextBase, margin: '8px 0' }}>
                    <strong>应用类型</strong>&nbsp;&nbsp;
                    {
                        appType.length + appModal.length > 0 ? <Avatar size={15} style={{ backgroundColor: colorPrimaryBg, color: colorPrimary, fontSize: fontSizeSM, marginTop: -2, }}>{appType.length + appModal.length}</Avatar> : ''
                    }
                </div>
                <div style={{ color: CNF.basePlaceholderColor, fontSize: fontSizeSM, marginBottom: marginBottom }}>类别</div>
                <Space wrap style={{ marginBottom: marginBottom }}>
                    <Button
                        size='small'
                        color='default'
                        style={{
                            borderColor: appType.indexOf('工作流') > -1 ? colorPrimaryBorder : colorBgSolid,
                            background: appType.indexOf('工作流') > -1 ? colorPrimaryBg : colorBgActive,
                            color: appType.indexOf('工作流') > -1 ? colorPrimaryText : colorTextMenu,
                        }}
                        icon={<NodeIndexOutlined />}
                        onClick={() => {
                            changeAppType('工作流');
                        }}
                    >工作流</Button>
                </Space>
                <div style={{ color: CNF.basePlaceholderColor, fontSize: fontSizeSM, marginBottom: marginBottom }}>模态</div>
                <Space wrap style={{ marginBottom: marginBottom }}>
                    <Button
                        size='small'
                        color='default'
                        style={{
                            borderColor: appModal.indexOf('文本') > -1 ? colorPrimaryBorder : colorBgSolid,
                            background: appModal.indexOf('文本') > -1 ? colorPrimaryBg : colorBgActive,
                            color: appModal.indexOf('文本') > -1 ? colorPrimary : colorTextMenu,
                        }}
                        icon={<TextIcon />}
                        onClick={() => {
                            changeAppModal('文本');
                        }}
                    >文本</Button>
                </Space>
                <div style={{ color: colorTextBase, margin: '16px 0 8px 0' }}>
                    <strong>应用领域</strong>&nbsp;&nbsp;
                    {
                        appFiled.length > 0 ? <Avatar size={15} style={{ backgroundColor: colorPrimaryBg, color: colorPrimary, fontSize: fontSizeSM, marginTop: -2, }}>{appFiled.length}</Avatar> : ''
                    }
                </div>
                <div style={{ color: CNF.basePlaceholderColor, fontSize: fontSizeSM, marginBottom: marginBottom }}>领域</div>
                <Space wrap style={{ marginBottom: marginBottom }}>
                    {
                        CNF.appFileds.map((item, index) => {
                            return <Button
                                key={index}
                                size='small'
                                color='default'
                                style={{
                                    borderColor: appFiled.indexOf(item.label) > -1 ? colorPrimaryBorder : colorBgSolid,
                                    background: appFiled.indexOf(item.label) > -1 ? colorPrimaryBg : colorBgActive,
                                    color: appFiled.indexOf(item.label) > -1 ? colorPrimary : colorTextMenu,
                                }}
                                icon={item.icon}
                                onClick={() => {
                                    changeAppFiled(item.label);
                                }}
                            >{item.label}</Button>
                        })
                    }
                </Space>
            </div>
            {/* 标签栏 */}

            {/* 卡片栏 */}
            <div style={{ width: '86%', padding: CNF.basePadding, }}>
                <div style={{ color: colorTextBase, margin: '8px 0' }}>
                    <strong>应用模版</strong>&nbsp;&nbsp;
                    <span style={{ color: CNF.basePlaceholderColor }}>{appList.length}</span>
                </div>
                <Flex wrap gap={CNF.basePadding} style={{
                    marginBottom: CNF.basePadding,
                }}>
                    {
                        appList.map((item, index) => {
                            return <Card
                                key={index}
                                hoverable={true}
                                loading={false}
                                style={{
                                    height: 171,
                                    maxWidth: '24%',
                                    minWidth: '24%',
                                    cursor: 'pointer',
                                }}
                                styles={{
                                    root: {
                                        border: `1px solid ${hoverIndex === index ? colorPrimary : colorBgSolid}`,
                                    },
                                }}
                                onClick={() => {
                                    props.setUri(props.appRunUri + item.app_id);
                                }}
                                onMouseEnter={() => { setHoverIndex(index); }}
                                onMouseLeave={() => { setHoverIndex(-1); }}
                            >
                                <div style={{ color: colorTextBase, fontSize: fontSizeLG }}>
                                    <Avatar shape='square' size={36} src={item.app_icon} />
                                    &nbsp;&nbsp;
                                    <strong>{item.app_name}</strong>
                                </div>
                                <Paragraph
                                    style={{ color: colorBasePlaceholder, fontSize: fontSizeSM, margin: '8px 0 18px 0' }}
                                    ellipsis={{
                                        rows: 2,
                                        symbol: '...',
                                        tooltip: <Tooltip>{item.app_description}</Tooltip>,
                                    }}
                                >
                                    {item.app_description}
                                </Paragraph>
                                <Flex>
                                    {/* 应用标签 */}
                                    <div style={{ width: '80%', }}>
                                        <Flex gap='small'>
                                            {
                                                item.app_tags && item.app_tags.split('|').map((tag, index) =>
                                                    <Tag key={index} style={{ color: colorTextBase, }} size='small' variant='filled'>{tag}</Tag>
                                                )
                                            }
                                            <Tag style={{ color: colorTextBase, }} size='small' variant='filled'>{item.app_type}</Tag>
                                            <Tag style={{ color: colorTextBase, }} size='small' variant='filled'>{item.app_filed}</Tag>
                                        </Flex>
                                    </div>
                                    {/* 应用标签 */}
                                    {/* 调用数据 */}
                                    <div style={{ width: '20%', textAlign: 'right' }}>
                                        <Text style={{ color: colorBasePlaceholder, fontSize: fontSizeSM }}><PlayCircleOutlined />&nbsp;&nbsp;
                                            {item.run_count}
                                        </Text>
                                    </div>
                                    {/* 调用数据 */}
                                </Flex>
                            </Card>
                        })
                    }
                </Flex>
            </div >
            {/* 卡片栏 */}
        </Flex >
    </>
}

export default AppMarket;